const win = window as any

const isStubMode =
  process?.env?.REACT_APP_STUB_MODE || win?.babylonConfig?.REACT_APP_STUB_MODE
const isE2eMode =
  process?.env?.REACT_APP_E2E_MODE || win?.babylonConfig?.REACT_APP_E2E_MODE

export { isStubMode, isE2eMode }
